export default {
  notificationTabs: (state) => state.notificationTabs,
  notifications: (state) => state.notifications,
  rolesNotification: (state) => state.rolesNotification,
  myOrders: (state) => state.myOrders,
  testOrders: (state) => state.testOrders
};
